import React, { useContext, useEffect, useState } from 'react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import ActionContext from '../../../context/ActionContext';
import overviewIcon from '../../../assets/bankbox-icon-overview.svg';
import walletIcon from '../../../assets/sidenav-icon-wallet.svg';
import transactionIcon from '../../../assets/bankbox-icon-transaction.svg';
import terminalIcon from '../../../assets/bankbox-icon-terminal.svg';
import requestIcon from '../../../assets/bankbox-icon-request.svg';
import disputeIcon from '../../../assets/bankbox-icon-disputes.svg';
import feeIcon from '../../../assets/bankbox-icon-fee.svg';
import customerIcon from '../../../assets/bankbox-icon-users.svg';
import settingIcon from '../../../assets/bankbox-icon-settings.svg';
import settlementIcon from '../../../assets/bank_box_icon_settlement.svg';
import billsIcon from '../../../assets/bankbox_icon_bills.svg';

import compliance from '../../../assets/bankbox-icon-compliance.svg';
import {
	trimLongString,
	mapHotkey,
	getCookie,
	setCookie,
	getActionNamesByPolicyName,
	capitalizeFirstLetter,
	returnInitial,
} from '../../../utils/helper/Helper';
import './style/index.css';
import onboardingIcon from '../../../assets/sidenav-icon-onboarding.svg';
// import { sideMenuList } from './SidemenuList';
import { useLocation, useNavigate } from 'react-router-dom';
import {
	RavenButton,
	RavenToolTip,
	RavenWindowSize,
} from '@ravenpay/raven-bank-ui';
import RootState from '../../../redux/types';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMenu } from '../../../redux/actions/actions';

import { bankboxAPI } from '../../../redux/bankbox';
import { icons } from '../../../assets/icons';
import { ALL_ROUTES } from '../../../routes/dashboard/overview/AllPathNames';
import { Icons } from '../../../pages/dashboard/bankbox/users/cameraAssign/webcam/icons';
import { Sidemenwicons } from '../../../assets/icons/SidemenuIcons';
import useWindowSize from '../../../hooks/UseWindowSize';

interface MyComponentProps {
	theme: any;
}

const SideMenuComponent: React.FC<MyComponentProps> = ({ theme }) => {
	const [kycStatus, setKycStatus] = useState<boolean>(true);
	const { isMenuOpen } = useSelector((state: RootState) => state.general);

	const { partner_info, banks } = useSelector(
		(state: RootState) => state.bankbox
	);
	// const { profile } = useSelector((state: RootState) => state.wallet);
	const { profile } = useSelector((state: RootState) => state.settings);

	//check if x-pos-key exists and update cache

	// const xposKey = cachdKey || profile?.partnerDetails?.appKey;
	const cachdKey = getCookie('x-pos-key');
	// const isAppkeyDenounced = getCookie('denounce-bankbox');

	useEffect(() => {
		// //(profile);
		// //(cachdKey);

		if (profile?.partnerDetails?.appKey) {
			setCookie('x-pos-key', cachdKey || profile?.partnerDetails?.appKey, 3000);
		}
	}, [profile]);

	const ravenWhiteLogo = (prop?: any) => {
		return (
			<svg
				width="97"
				height="22"
				viewBox="0 0 97 22"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M28.1441 8.04396C28.155 8.05789 28.1763 8.10115 28.2105 8.12877C29.8366 9.45477 30.1369 11.3483 28.939 13.0745C27.9251 14.5353 26.5106 15.3082 24.7114 15.2895C23.4819 15.2768 22.2526 15.2386 21.0249 15.1844C20.5705 15.1645 20.1995 15.253 19.8322 15.5489C19.1502 16.099 18.3447 16.4092 17.3784 16.6024C17.4527 16.3598 17.4934 16.1761 17.5646 16.0052C18.2369 14.3885 18.9157 12.7743 19.5886 11.1571C19.6807 10.9358 19.7495 10.7049 19.8293 10.4785C19.785 10.4511 19.7402 10.4232 19.696 10.3959C19.5918 10.5168 19.4685 10.6259 19.3865 10.7598C18.8867 11.5745 18.4067 12.4004 17.8993 13.2101C17.5736 13.73 17.2322 14.2423 16.8647 14.7337C15.4488 16.6268 13.5225 17.6288 11.2026 17.926C10.9321 17.9604 10.6615 17.9948 10.3901 18.021C10.3259 18.0269 10.2586 17.9989 10.0883 17.9668C11.3377 16.0738 12.6116 14.2572 13.8582 12.4227C15.0899 10.6097 16.324 8.79856 17.5575 6.98679C17.5094 6.94753 17.4613 6.90826 17.4127 6.86957C17.2573 7.0435 17.0932 7.21068 16.9483 7.3932C15.8004 8.83594 14.6653 10.2885 13.5082 11.7239C12.1491 13.4095 10.7138 15.0254 9.0328 16.4051C7.46579 17.6909 5.75324 18.6972 3.74805 19.1353C2.57914 19.3909 0.935976 19.3641 0.00534949 19.0684C0.0465121 18.7638 0.314843 18.6387 0.507764 18.4777C1.61001 17.5603 2.7306 16.6648 3.83455 15.7498C8.2388 12.1015 12.4815 8.27857 16.3613 4.06808C17.0861 3.28165 17.7976 2.48122 18.4818 1.65988C18.7767 1.30623 19.1123 1.17232 19.5508 1.18942C21.8242 1.28073 24.0985 1.36081 26.3718 1.45981C26.8002 1.4784 27.2373 1.5227 27.6495 1.63266C30.1278 2.29489 30.9303 4.84648 29.2862 6.82795C28.9397 7.2459 28.5429 7.62156 28.1436 8.04335L28.1441 8.04396ZM20.9913 13.1586C21.1573 13.2166 21.24 13.2693 21.3234 13.2717C22.2985 13.2932 23.2739 13.3254 24.2486 13.3174C24.933 13.3118 25.4532 12.9503 25.8515 12.4182C26.2153 11.9321 26.3856 11.3753 26.3922 10.7653C26.4013 9.87218 25.8584 9.12467 24.9845 9.04318C23.9281 8.94469 22.86 8.96673 21.7021 8.93411C21.4616 10.3645 21.2268 11.7583 20.9907 13.158L20.9913 13.1586ZM22.0683 6.93558C23.1474 6.96599 24.169 7.08008 25.1749 6.99883C26.1551 6.91982 26.8911 5.77648 26.802 4.71475C26.7254 3.79674 26.1369 3.33941 24.9686 3.30234C24.3779 3.28392 23.7864 3.27258 23.1957 3.27608C22.7151 3.27913 22.6513 3.33716 22.567 3.80456C22.4463 4.47472 22.3343 5.14691 22.2253 5.81918C22.1686 6.17006 22.1255 6.5231 22.0683 6.93558Z"
					fill={prop || 'white'}
				/>
				<path
					d="M42.0895 5.22143L40.4687 14.8094L37.4279 14.7238L37.7323 12.8775C36.8668 14.2038 35.7678 14.8571 34.4543 14.8201C32.6371 14.7689 30.3521 13.4261 30.9598 9.75191C31.5695 6.00555 34.3935 4.82509 36.2652 4.87782C37.3627 4.90875 38.2141 5.3646 38.8562 6.22924L39.0487 5.13635L42.0895 5.22202L42.0895 5.22143ZM38.121 10.5834L38.5082 8.3432C38.0725 7.19647 37.4766 6.60327 36.7391 6.58249C36.1093 6.56474 35.5431 6.85506 35.0216 7.47009C34.5184 8.06787 34.1718 8.86851 34.0178 9.85467C33.8659 10.7686 33.8985 11.5438 34.1324 12.1807C34.3845 12.8181 34.7897 13.1358 35.3834 13.1526C36.3009 13.1784 37.2077 12.3219 38.121 10.5828L38.121 10.5834Z"
					fill={prop || 'white'}
				/>
				<path
					d="M52.8946 9.01903L51.8581 15.1301L48.8173 15.0444L49.833 9.04058C49.9315 8.089 49.9823 6.9382 48.9748 6.90982C48.0751 6.88446 47.1679 7.77713 46.2708 9.57053L45.3628 14.9471L42.322 14.8614L43.9429 5.2734L46.9836 5.35907L46.6803 7.16921C47.5636 5.86178 48.6799 5.22678 50.0289 5.26479C52.1338 5.3241 53.2436 6.85 52.894 9.01901L52.8946 9.01903Z"
					fill={prop || 'white'}
				/>
				<path
					d="M60.6236 9.50807L63.3908 15.4562L59.954 15.3593L58.3739 11.3712L57.2668 12.3121L56.7694 15.269L53.7109 15.1828L56.0212 1.56339L59.0619 1.64907L57.6997 9.73195L62.3846 5.79415L64.8317 5.8631L60.6236 9.50807Z"
					fill={prop || 'white'}
				/>
				<path
					d="M75.0801 12.1303C74.8886 13.1693 74.3788 14.0193 73.5493 14.6985C72.7198 15.3771 71.7204 15.6914 70.5874 15.6594L64.7581 15.4952L66.9373 2.69964L72.2091 2.84818C74.6384 2.91663 75.9316 4.30375 75.5865 6.31057C75.3919 7.45731 74.7373 8.33932 73.6038 8.9377C74.7404 9.49164 75.3195 10.6785 75.0801 12.1303ZM73.1191 12.075C73.4809 10.1042 72.0733 9.5788 71.2991 9.55699L67.7368 9.45661L66.8959 14.367L70.4765 14.4679C71.2324 14.4892 72.8121 14.0113 73.1191 12.0756L73.1191 12.075ZM67.9325 8.27377L71.2431 8.36705C71.9807 8.38783 73.3409 8.04821 73.6438 6.25583C73.9477 4.42794 72.7154 4.05081 71.9418 4.02901L68.6672 3.93675L67.9331 8.27378L67.9325 8.27377Z"
					fill={prop || 'white'}
				/>
				<path
					d="M77.4053 14.6075C76.6224 13.6311 76.3682 12.4356 76.6064 11.0015C76.8442 9.58588 77.5075 8.41561 78.5963 7.49252C79.7028 6.56934 80.9573 6.13669 82.3608 6.17623C83.7642 6.21578 84.8485 6.71433 85.6131 7.69023C86.3959 8.66666 86.6502 9.86218 86.4124 11.2778C86.1736 12.7118 85.5109 13.8815 84.4221 14.8052C83.3339 15.7289 82.0788 16.1615 80.6753 16.122C79.2719 16.0825 78.1876 15.5839 77.4047 14.6075L77.4053 14.6075ZM83.1685 13.9233C83.874 13.169 84.3131 12.2809 84.5052 11.2241C84.6785 10.1846 84.5416 9.28027 84.0775 8.51128C83.6317 7.72445 82.9942 7.32853 82.1666 7.30522C81.3391 7.2819 80.5726 7.63825 79.8671 8.39265C79.1621 9.12928 78.723 10.0168 78.5314 11.0558C78.3577 12.1131 78.4939 13.0174 78.9403 13.8042C79.405 14.5738 80.0419 14.9697 80.8695 14.993C81.697 15.0163 82.4635 14.66 83.1685 13.9233Z"
					fill={prop || 'white'}
				/>
				<path
					d="M90.1146 11.5272L87.4654 6.50061L89.7686 6.56551L91.6502 10.0936L94.951 6.71153L96.3906 6.75209L92.1653 11.0085L94.878 16.3431L92.5932 16.2788L90.6481 12.4604L87.1598 16.1257L85.7386 16.0856L90.1169 11.5272L90.1146 11.5272Z"
					fill={prop || 'white'}
				/>
			</svg>
		);
	};

	const actionCtx = useContext(ActionContext);

	const location = useLocation();
	const navigate = useNavigate();

	const dispatch = useDispatch();

	const sideMenuList = [
		{
			title: 'Main Menu',
			links: [
				{
					name: 'Overview',
					link: ALL_ROUTES?.OVERVIEW,
					icon: Sidemenwicons?.overviewIcon,
					icon_fade: Sidemenwicons?.overviewIcon_fade,
					hide: getActionNamesByPolicyName(
						profile?.rolePolicies?.policies,
						'overview'
					)?.includes('view_overview')
						? false
						: true,
				},

				{
					name: 'Merchants',
					link: ALL_ROUTES?.BANKBOX_USER,
					icon: Sidemenwicons?.merchantIcon,
					icon_fade: Sidemenwicons?.merchantIcon_fade,
					hide: getActionNamesByPolicyName(
						profile?.rolePolicies?.policies,
						'merchants'
					)?.includes('view_merchants')
						? false
						: true,
				},

				{
					name: 'Terminals',
					link: ALL_ROUTES?.BANKBOX_TERMINALS,
					icon: Sidemenwicons?.terminalIcon,
					icon_fade: Sidemenwicons?.terminalIcon_fade,
					hide: getActionNamesByPolicyName(
						profile?.rolePolicies?.policies,
						'terminals'
					)?.includes('view_terminals')
						? false
						: true,
					related_links: [
						ALL_ROUTES?.PHYSICAL_TERMINALS,
						ALL_ROUTES?.VIRTUAL_TERMINALS,
					],
				},

				{
					name: 'Transactions',
					link: ALL_ROUTES?.BANKBOX_TRANSACTIONS,
					icon: Sidemenwicons?.transactionIcon,
					icon_fade: Sidemenwicons?.transactionIcon_fade,
					hide: getActionNamesByPolicyName(
						profile?.rolePolicies?.policies,
						'transactions'
					)?.includes('view_transactions')
						? false
						: true,
					children: [],
					related_links: [
						ALL_ROUTES?.BANKBOX_TRANSACTIONS,
						ALL_ROUTES?.SINGLE_MERCHANT_BANKBOX_TRANSACTIONS,
					],
				},
			],
		},
		{
			title: 'FEATURES',
			links: [
				// {
				// 	name: 'Tapverse',
				// 	link: '/dashboard-tapverse',
				// 	icon: Sidemenwicons?.tapverse,
				// 	icon_fade: Sidemenwicons?.tapverse_fade,
				// 	related_links: ['/dashboard-tapverse'],
				// 	children: [
				// 		{
				// 			name: 'Insight',
				// 			link: ALL_ROUTES?.TAPVERSE_INSIGHT,
				// 			icon: Sidemenwicons?.insight,
				// 			icon_fade: Sidemenwicons?.insight_fade,
				// 			related_links: [ALL_ROUTES?.TAPVERSE_INSIGHT],
				// 			hide: false,
				// 		},
				// 		{
				// 			name: 'Repayment',
				// 			link: ALL_ROUTES?.TAPVERSE_REPAYMENT,
				// 			icon: Sidemenwicons?.repayment,
				// 			icon_fade: Sidemenwicons?.repayment_fade,
				// 			related_links: [ALL_ROUTES?.TAPVERSE_REPAYMENT],
				// 			hide: false,
				// 		},
				// 	],
				// },
				{
					name: 'Requests',
					link: ALL_ROUTES?.BANKBOX_REQUEST,
					icon: Sidemenwicons?.reqIcon,
					icon_fade: Sidemenwicons?.reqIcon_fade,
					hide: getActionNamesByPolicyName(
						profile?.rolePolicies?.policies,
						'bankbox requests'
					)?.includes('view_bankbox_requests')
						? false
						: true,
					related_links: [
						ALL_ROUTES?.BANKBOX_REQUEST,
						ALL_ROUTES?.PARTNERS_REQ,
					],
				},

				{
					name: 'Settlement',
					link: '/dashboard-settlement',
					icon: Sidemenwicons?.settlementIcon,
					icon_fade: Sidemenwicons?.settlementIcon_fade,
					// hide: getActionNamesByPolicyName(
					// 	profile?.rolePolicies?.policies,
					// 	'settlement'
					// )?.includes('settlement')
					// 	? false
					// 	: true,
					related_links: ['/dashboard-settlement'],
					children: [
						{
							name: 'Settlement History',
							link: ALL_ROUTES?.SETTLEMENT_GENERAL,
							icon: Sidemenwicons?.settlementHistory,
							icon_fade: Sidemenwicons?.settlementHistory_fade,
							related_links: [ALL_ROUTES?.SETTLEMENT_GENERAL],
							hide: false,
						},
						{
							name: 'New Account Request',
							link: ALL_ROUTES?.SETTLEMENT_HISTORY,
							icon: Sidemenwicons?.settlementAccountChnage,
							icon_fade: Sidemenwicons?.settlementAccountChnage_fade,
							related_links: [ALL_ROUTES?.SETTLEMENT_HISTORY],
							hide: false,
						},
					],
				},
				{
					name: 'Bills',
					link: ALL_ROUTES?.BILLS,
					icon: Sidemenwicons?.billsIcon,
					icon_fade: Sidemenwicons?.billsIcon_fade,
					// hide: getActionNamesByPolicyName(
					// 	profile?.rolePolicies?.policies,
					// 	'bills'
					// )?.includes('settlement')
					// 	? false
					// 	: true,
					related_links: [
						ALL_ROUTES?.BILLS_DATA,
						ALL_ROUTES?.BILLS_ELECTRICITY,
						ALL_ROUTES?.BILLS_BETTING,
						ALL_ROUTES?.BILLS_CABLE,
					],
				},
				{
					name: 'Fee Details',
					link: ALL_ROUTES?.FEE_DETAILS,
					icon: Sidemenwicons?.feeIcon,
					icon_fade: Sidemenwicons?.feeIcon_fade,
					hide: getActionNamesByPolicyName(
						profile?.rolePolicies?.policies,
						'fee details'
					)?.includes('view_fee_details')
						? false
						: true,
				},
			],
		},
		{
			title: 'SUPPORT',
			links: [
				{
					name: 'Disputes',
					link: ALL_ROUTES?.DISPUTES,
					icon: Sidemenwicons?.disputeIcon,
					icon_fade: Sidemenwicons?.disputeIcon_fade,
					hide: getActionNamesByPolicyName(
						profile?.rolePolicies?.policies,
						'disputes'
					)?.includes('view_disputes')
						? false
						: true,
				},
				// {
				// 	name: 'Compliance',
				// 	link: ALL_ROUTES?.COMPLIANCE_BVN_VERIFICATION,
				// 	icon: Sidemenwicons?.complianceIcon,
				// 	icon_fade: Sidemenwicons?.complianceIcon_fade,
				// 	active: location.pathname.startsWith('/dashboard-compliance-'),
				// 	hide: getActionNamesByPolicyName(
				// 		profile?.rolePolicies?.policies,
				// 		'compliance'
				// 	)?.includes('view_compliance')
				// 		? false
				// 		: true,
				// 	related_links: [
				// 		ALL_ROUTES?.COMPLIANCE_BVN_VERIFICATION,
				// 		ALL_ROUTES?.COMPLIANCE_ADDRESS_VERIFICATION,
				// 		ALL_ROUTES?.COMPLIANCE_CAC_VERIFICATION,
				// 		// ALL_ROUTES?.COMPLIANCE_CARDLIST,
				// 		ALL_ROUTES?.UPLOAD_CAC,
				// 		ALL_ROUTES?.COMPLIANCE_NIN_VERIFICATION,
				// 	],
				// 	children: [],
				// },

				{
					name: 'Settings',
					link: ALL_ROUTES?.BANBOX_SETTINGS,
					icon: Sidemenwicons?.settingsIcon,
					icon_fade: Sidemenwicons?.settingsIcon_fade,
					related_links: [
						ALL_ROUTES?.BANBOX_SETTINGS,
						ALL_ROUTES?.TEAM_SETTINGS_INDEX,
						ALL_ROUTES?.ROLES_AND_PERMISSION,
						ALL_ROUTES?.SETTINGS_ROLE_SINGLE,
					],
					hide: getActionNamesByPolicyName(
						profile?.rolePolicies?.policies,
						'settings'
					)?.includes('view_settings')
						? false
						: true,
				},
			],
		},
	];

	// if (Object?.keys(profile)?.length < 1) {
	// 	return <React.Fragment></React.Fragment>;
	// }

	const statusVal =
		partner_info?.partner_info?.status || profile?.partnerDetails?.status;

	// useEffect(() => {
	// 	//(profile);
	// }, []);

	const dropIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
			className="img"
		>
			<path
				stroke="#E5E6E6"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.4"
				d="M12 10 8 6l-4 4"
			></path>
		</svg>
	);

	function generateLinearGradient(color: string): string {
		// Create a temporary element to use browser's color parsing
		const temp = document.createElement('div');
		temp.style.color = color;
		document.body.appendChild(temp);

		// Get computed color (in rgb format)
		const computedColor = getComputedStyle(temp).color;
		document.body.removeChild(temp);

		const rgbMatch = computedColor.match(/\d+/g);

		if (!rgbMatch || rgbMatch.length < 3) {
			throw new Error('Invalid color format');
		}

		const [r, g, b] = rgbMatch.map(Number);

		// Create a darker version by mixing with black (50% darkened)
		const darkR = Math.floor(r * 0.5);
		const darkG = Math.floor(g * 0.5);
		const darkB = Math.floor(b * 0.5);

		const gradient = `linear-gradient(to bottom, rgb(${r}, ${g}, ${b}), rgb(${darkR}, ${darkG}, ${darkB}))`;
		return gradient;
	}

	function generateDeepDarkGradient(color: string): string {
		// Create a temporary element to use browser's color parsing
		const temp = document.createElement('div');
		temp.style.color = color;
		document.body.appendChild(temp);

		// Get computed color in rgb format
		const computedColor = getComputedStyle(temp).color;
		document.body.removeChild(temp);

		const rgbMatch = computedColor.match(/\d+/g);
		if (!rgbMatch || rgbMatch.length < 3) {
			throw new Error('Invalid color format');
		}

		const [r, g, b] = rgbMatch.map(Number);

		// Create darker and darkest shades
		const midR = Math.floor(r * 0.5);
		const midG = Math.floor(g * 0.5);
		const midB = Math.floor(b * 0.5);

		const endR = Math.floor(r * 0.2);
		const endG = Math.floor(g * 0.2);
		const endB = Math.floor(b * 0.2);

		// Gradient with three stops: start, mid (50%), end (100%)
		const gradient = `linear-gradient(to bottom, rgb(${r}, ${g}, ${b}) 0%, rgb(${midR}, ${midG}, ${midB}) 50%, rgb(${endR}, ${endG}, ${endB}) 100%)`;

		return gradient;
	}

	const collapseLogoIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="30"
			height="19"
			fill="none"
			viewBox="0 0 30 19"
			className="icon"
		>
			<path
				fill="#fff"
				d="M27.817 6.61c.011.014.034.056.069.083 1.663 1.28 2.016 3.164.867 4.923-.972 1.489-2.364 2.301-4.163 2.333-1.23.022-2.46.019-3.688 0-.455-.008-.823.09-1.182.397-.666.57-1.463.902-2.423 1.122.067-.244.103-.43.169-.602.627-1.635 1.26-3.268 1.887-4.903.085-.224.148-.457.221-.685l-.136-.08c-.1.125-.22.237-.298.373-.477.829-.934 1.668-1.418 2.492a22 22 0 0 1-.992 1.552c-1.361 1.932-3.259 2.988-5.57 3.35q-.403.065-.809.118c-.064.008-.132-.018-.303-.046 1.195-1.927 2.418-3.779 3.612-5.648q1.771-2.77 3.545-5.538l-.148-.113c-.15.178-.31.35-.45.537-1.106 1.474-2.2 2.958-3.316 4.426-1.311 1.723-2.7 3.378-4.342 4.805-1.53 1.33-3.214 2.384-5.206 2.878-1.161.288-2.804.308-3.743.038.033-.305.297-.438.486-.604 1.076-.948 2.17-1.875 3.248-2.82 4.3-3.772 8.433-7.712 12.193-12.03A64 64 0 0 0 17.979.5c.285-.361.616-.505 1.055-.5 2.275.027 4.55.043 6.826.078.429.007.867.039 1.282.137 2.496.592 3.37 3.12 1.782 5.147-.334.428-.72.814-1.107 1.247m-7.006 5.314c.168.053.252.104.335.104.976-.006 1.951-.002 2.926-.037.684-.025 1.194-.401 1.577-.944.35-.496.504-1.058.493-1.668-.015-.893-.58-1.624-1.455-1.681-1.059-.069-2.126-.017-3.284-.017zm.901-6.25c1.08 0 2.104.084 3.108-.025.977-.107 1.68-1.27 1.562-2.33-.103-.915-.704-1.355-1.873-1.36a48 48 0 0 0-1.773.024c-.48.017-.542.077-.613.546q-.152 1.011-.285 2.024c-.047.352-.08.706-.126 1.12"
			></path>
		</svg>
	);

	const collapseIcon = (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className="img"
		>
			<path
				d="M20 7H11M14 17H5M14 17C14 18.6569 15.3431 20 17 20C18.6569 20 20 18.6569 20 17C20 15.3431 18.6569 14 17 14C15.3431 14 14 15.3431 14 17ZM10 7C10 8.65685 8.65685 10 7 10C5.34315 10 4 8.65685 4 7C4 5.34315 5.34315 4 7 4C8.65685 4 10 5.34315 10 7Z"
				stroke="white"
				style={{ stroke: 'white', strokeOpacity: 1 }}
				strokeWidth="1.33"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);

	const conditionCollapse =
		Number(useWindowSize()?.width) < 1200 || actionCtx?.collapseNav;

	return (
		<>
			<div
				style={{
					background:
						theme === 'light'
							? `${generateDeepDarkGradient('var(--primary-base-color)')}`
							: '',
				}}
				className={`dashboard-sidemenu-wrap ${
					actionCtx?.collapseNav ? 'dashboard-sidemenu-wrap-collapse' : ''
				}`}
			>
				{/* logo box start */}
				<div className="logo-text-box">
					<div className="logo-box">
						<figure className="img-box">
							{conditionCollapse ? collapseLogoIcon : ravenWhiteLogo('#ffffff')}
						</figure>
					</div>
					{/* <div className="text side-nav-logo-text">Bankbox</div> */}
				</div>
				{/* logo box end */}
				{/* collapse icon start */}
				<div
					onClick={() => {
						actionCtx?.setCollapseNav(!actionCtx?.collapseNav);
					}}
					className="collapse-icon-box-wrap"
				>
					<figure className="img-box tooltip-hover-wrap">
						{' '}
						{/* <RavenToolTip
							position="bottom-right"
							text="Collapse Nav"
							color="deep-green-light"
						/> */}
						{collapseIcon}
					</figure>
				</div>
				{/* collapse icon box end */}
				{/* email name box start */}
				{Object?.keys(profile)?.length > 0 && (
					<div
						onClick={() => {
							// //(profile);
							// //(
							// 	getActionNamesByPolicyName(
							// 		profile?.rolePolicies?.policies,
							// 		'roles'
							// 	)
							// );
						}}
						className="name-email-drop-box remove-dark-theme-border border-theme transparent-fade-white-bg"
					>
						<div className="name-email-box">
							{conditionCollapse ? (
								<>
									<p style={{ textTransform: 'capitalize' }} className="name">
										{returnInitial(`${profile?.partnerDetails?.business_name}`)}
									</p>
								</>
							) : (
								<p style={{ textTransform: 'capitalize' }} className="name">
									{trimLongString(
										profile?.partnerDetails?.business_name ||
											`${profile?.user?.first_name || ''} ${
												profile?.user?.last_name || ''
											}`,
										15
									) || ''}
								</p>
							)}
							<p className="email">
								{`${trimLongString(
									capitalizeFirstLetter(profile?.user?.role) ||
										profile?.user?.email,
									25
								)}`}
							</p>
						</div>
						{/* <div className="icon-box">
						<FaAngleDown className="icon" />
					</div> */}
					</div>
				)}
				{/* email name box end */}
				{/* nav list start */}
				<div className="nav-list-box">
					{/* title start */}
					<div
						style={{
							opacity: !kycStatus ? 0.5 : 1,
							cursor: !kycStatus ? 'no-drop' : '',
							pointerEvents: !kycStatus ? 'none' : 'auto',
						}}
						className="toggle-nav-box"
					>
						<div style={{ marginTop: '1.6rem' }} className="get-started">
							<p className="title">
								{String(statusVal) === '0' ? `PROFILE SET UP` : ``}
							</p>
						</div>
					</div>
					{/* title end  */}
					{/* list start */}
					{String(statusVal) === '1' && (
						<div
							style={{
								opacity: !kycStatus ? 0.5 : 1,
								cursor: !kycStatus ? 'no-drop' : '',
								pointerEvents: !kycStatus ? 'none' : 'auto',
							}}
							className="list-box"
						>
							{/* title start */}

							{/* title end  */}
							{sideMenuList?.map((chi, idx) => {
								const { title, links } = chi;
								return (
									<React.Fragment key={idx}>
										<div
											className={`toggle-nav-box ${'toggle-nav-box-two border-theme-top'}`}
										>
											<div className="get-started">
												<p className="title">{title}</p>
											</div>
										</div>
										{links?.map((ch, i) => {
											const {
												name,
												icon,
												link,
												hide,
												related_links,
												children,
												icon_fade,
											} = ch;
											if (hide) {
												return <React.Fragment key={idx}></React.Fragment>;
											}

											if (Number(children?.length) > 0) {
												return (
													<div
														key={idx}
														className={`children-main-wrapper-box`}
													>
														{/* parent here start */}
														<div
															onClick={() => {
																if (
																	cachdKey ||
																	profile?.partnerDetails?.appKey
																) {
																	actionCtx?.sideMenuDrop === name
																		? actionCtx?.setSideMenuDrop('')
																		: actionCtx?.setSideMenuDrop(name);
																}
															}}
															style={{
																cursor: !kycStatus
																	? 'no-drop'
																	: cachdKey || profile?.partnerDetails?.appKey
																	? 'pointer'
																	: 'not-allowed',
																pointerEvents: !kycStatus ? 'none' : 'auto',
																// cursor: xposKey && cachdKey ? 'pointer' : 'not-allowed',
															}}
															className={`nav-link ${
																location?.pathname.includes(link) &&
																'nav-link-active'
															} ${
																Number(related_links?.length) > 0 &&
																related_links?.includes(location?.pathname) &&
																'nav-link-active'
															} `}
														>
															<div className="img-wrap tooltip-hover-wrap">
																{conditionCollapse ? (
																	<>
																		<RavenToolTip
																			position="right"
																			color="deep-green-light"
																			text={name}
																			// portalId="portal-id-root"
																			// zIndex={5000}
																		/>
																	</>
																) : (
																	''
																)}
																<figure className="img-box">
																	{location?.pathname.includes(link) ||
																	(Number(related_links?.length) > 0 &&
																		related_links?.includes(location?.pathname))
																		? icon
																		: icon_fade}
																</figure>
															</div>
															<p className="text">{name}</p>
															{/* drop icon start */}
															<div
																className={`drop-icon ${
																	actionCtx?.sideMenuDrop !== name
																		? 'drop-icon-show'
																		: ''
																}`}
															>
																<figure className="img-box-drop">
																	{dropIcon}
																</figure>
															</div>
															{/* drop icon end */}
														</div>
														{/* parent here end */}
														{/* drop down box start */}
														<div
															className={`drop-chidren-box-wrap ${
																actionCtx?.sideMenuDrop === name
																	? 'drop-chidren-box-wrap-show'
																	: ''
															}`}
														>
															{children?.map((drop_chi, drop_idx) => {
																if (drop_chi?.hide) {
																	return (
																		<React.Fragment
																			key={`${idx}-${drop_idx}`}
																		></React.Fragment>
																	);
																}
																return (
																	<div
																		key={`${idx}-${drop_idx}`}
																		onClick={() => {
																			if (
																				cachdKey ||
																				profile?.partnerDetails?.appKey
																			) {
																				navigate(drop_chi?.link);
																			}
																		}}
																		style={{
																			cursor: !kycStatus
																				? 'no-drop'
																				: cachdKey ||
																				  profile?.partnerDetails?.appKey
																				? 'pointer'
																				: 'not-allowed',
																			pointerEvents: !kycStatus
																				? 'none'
																				: 'auto',
																			// cursor: xposKey && cachdKey ? 'pointer' : 'not-allowed',
																		}}
																		className={`nav-link ${
																			location?.pathname.includes(
																				drop_chi?.link
																			) && 'nav-link-active'
																		} ${
																			drop_chi?.related_links?.includes(
																				location?.pathname
																			) && 'nav-link-active'
																		} nav-link-active-children-drop`}
																	>
																		<div className="img-wrap tooltip-hover-wrap">
																			{conditionCollapse ? (
																				<>
																					<RavenToolTip
																						position="right"
																						color="deep-green-light"
																						text={drop_chi?.name}
																						// portalId="portal-id-root"
																						// zIndex={5000}
																					/>
																				</>
																			) : (
																				''
																			)}
																			{(drop_chi?.icon ||
																				drop_chi?.icon_fade) && (
																				<figure className="img-box">
																					{location?.pathname.includes(
																						drop_chi?.link
																					) ||
																					drop_chi?.related_links?.includes(
																						location?.pathname
																					)
																						? drop_chi?.icon
																						: drop_chi?.icon_fade}
																				</figure>
																			)}
																		</div>
																		<p className="text">{drop_chi?.name}</p>
																	</div>
																);
															})}
														</div>
														{/* drop down box end */}
													</div>
												);
											}

											return (
												<div
													key={`${idx}-${name}`}
													onClick={() => {
														if (cachdKey || profile?.partnerDetails?.appKey) {
															navigate(link);
															actionCtx?.sideMenuDrop &&
																actionCtx?.setSideMenuDrop('');
														}
													}}
													style={{
														cursor: !kycStatus
															? 'no-drop'
															: cachdKey || profile?.partnerDetails?.appKey
															? 'pointer'
															: 'not-allowed',
														pointerEvents: !kycStatus ? 'none' : 'auto',
														// cursor: xposKey && cachdKey ? 'pointer' : 'not-allowed',
													}}
													className={`nav-link ${
														location?.pathname.includes(link) &&
														'nav-link-active'
													} ${
														related_links?.includes(location?.pathname) &&
														'nav-link-active'
													}`}
												>
													<div className="img-wrap tooltip-hover-wrap">
														{conditionCollapse ? (
															<>
																<RavenToolTip
																	position="right"
																	color="deep-green-light"
																	text={name}
																	// portalId="portal-id-root"
																	// zIndex={5000}
																/>
															</>
														) : (
															''
														)}
														<figure className="img-box">
															{location?.pathname.includes(link) ||
															(Number(related_links?.length) > 0 &&
																related_links?.includes(location?.pathname))
																? icon
																: icon_fade}
														</figure>
													</div>
													<p className="text">{name}</p>
												</div>
											);
										})}
									</React.Fragment>
								);
							})}
						</div>
					)}

					{/* list end */}
				</div>
				{/* nav list end */}
				{/* chat support box start */}
				{/* <div className="chat-support-box">
					<RavenButton
						onClick={() => window.fcWidget.open()}
						size="small"
						color="green-light"
						label="Help and Support"
					/>
				</div> */}
				{/* chat support box end */}
			</div>
		</>
	);
};

export default SideMenuComponent;
